import React from "react";
import { NodeViewWrapper, NodeViewProps } from "@tiptap/react";

/**
 * TipTap 편집기 안의 병원 노드 표시부(ReferenceButton NodeView 동형).
 *
 * spec 설계 결정 5: 편집 모드 중 병원 버튼 클릭은 **비활성**(패널 expand·스크롤이 에디터 포커스를
 * 흔드는 것 방지). 따라서 onClick 없이 실명만 비편집 span으로 보여준다. 직렬화(renderHTML)에서
 * data-hospital-alias/link를 유지하므로 저장 왕복에서 alias가 보존된다.
 *
 * spec 설계 결정 13: 클릭이 비활성이므로 이 노드는 "핸들러 없는 평문" 경로와 동일 취급이다. 밑줄·색·
 * 크기를 지정하지 않고 본문 글자와 똑같이 실명만 보여준다(옛 규격 fontSize 12·Blue 500·padding 폐기).
 */
const HospitalNodeView: React.FC<NodeViewProps> = ({ node }) => {
  const alias = node.attrs.alias;
  const text = node.attrs.text;

  if (!alias) {
    return null;
  }

  return (
    <NodeViewWrapper
      as="span"
      style={{ display: "inline" }}
      contentEditable={false}
      data-hospital-alias={alias}
      data-hospital-link="true"
    >
      <span title={text}>{text}</span>
    </NodeViewWrapper>
  );
};

export default HospitalNodeView;
